import { LocalDateTime } from "js-joda";
import { createFeatureSelector } from "@ngrx/store";
import { CORE_STATE_NAME } from "../../../redux/reducer/common/core.reducer";

/**
 * Simple reducer type of loadmask functionality for backend communication and navigation
 */
export interface CoreState {
  communicationProgressCount?: number;
  communicationStatus?: number;
  navigationInProgress?: boolean;
  navigationEnabled?: boolean;
  nextNavigationUrl?: string;
  currentNavigationUrl?: string;
  lastNavigationUrl?: string;
  systemDateTime?: LocalDateTime;

  clickToCall: string;
  startChat: string;
  callBack: string;
  locale?: string;

}

export const selectCoreState = createFeatureSelector<any, CoreState>(CORE_STATE_NAME);
